import React, { FormEvent, memo, useRef } from 'react';
import { IonicInput, IonicButton } from 'ionic-ui';
import { SendHorizonal } from 'lucide-react';
import debounceFn from '../../../utils/helperFunction/debounceFn';
type Props = {
  onSend: (msg: string) => void;
  onChange: () => void;
};

const ChatInput = memo(({ onSend, onChange }: Props) => {
  const formRef = useRef(null);
  const handleSubmission = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const msg = formData.get('chat_message');
    if (msg && !(msg as string).trim()) return;
    onSend(msg as string);
    event.currentTarget.reset();
  };
  const handleChange = debounceFn(() => onChange(), 250);

  return (
    <>
      {/* {attachment && (
        <small className='p-2 mb-1 flex items-center gap-1 w-full bg-gray-100 rounded-sm medium-emphasis-text'>
          <span className='flex-1'>
            {attachment.name}
          </span>
        </small>
      )} */}
      <form
        ref={formRef}
        onSubmit={handleSubmission}
        className="w-full flex items-center relative gap-1"
      >
        <IonicInput
          name="chat_message"
          containerClass="flex-1"
          placeholder="Type a message"
          onChange={handleChange}
          // suffix={
          //   <IonicButton
          //     onClick={handleAttachmentClick}
          //     className=" p-1 h-fit button-with-icon rounded-none bg-transparent hover:bg-transparent"
          //     type="button"
          //   >
          //     <IonIcon
          //       className="size-5 low-emphasis-text"
          //       icon={attachOutline}
          //     />
          //     <input
          //       type="file"
          //       ref={fileInputRef}
          //       disabled={Boolean(attachment)}
          //       className="hidden"
          //       onChange={handleFileChange}
          //       accept="image/*,application/pdf,.doc,.docx"
          //     />
          //   </IonicButton>
          // }
        />
        <IonicButton className="button-with-icon max-sm:px-2 rounded-md">
          <span className="max-sm:hidden">Send</span>
          <SendHorizonal />
        </IonicButton>
      </form>
    </>
  );
});

export default ChatInput;
